<span class="flex min-w-0 items-baseline gap-1.5 text-sm tracking-tight">
  <span class="shrink-0 text-zinc-500 tabular-nums">#{{ incidentId() }}</span>
  @if (incidentTitle(); as title) {
    <span class="truncate text-zinc-200">{{ title }}</span>
  }
</span>

<div class="flex min-w-0 items-center gap-2">
  @if (created(); as change) {
    @if (change.state; as state) {
      <app-incident-status-label [state]="state" [states]="states()" />
    }
    @if (change.priority; as priority) {
      <app-incident-priority-label [priority]="priority" />
    }
  }

  @if (stateChange(); as change) {
    <app-incident-status-label [state]="change.from" [states]="states()" />
    <vx-icon name="arrow-right" size="sm" class="shrink-0 text-zinc-500" />
    <app-incident-status-label [state]="change.to" [states]="states()" />
  }

  @if (priorityChange(); as change) {
    <app-incident-priority-label [priority]="change.from" />
    <vx-icon name="arrow-right" size="sm" class="shrink-0 text-zinc-500" />
    <app-incident-priority-label [priority]="change.to" />
  }
</div>
